

const Admin = () => {
  return (
    <>
      <h1>admin</h1>
    </>
  );
};

export default Admin;